import api from './axiosInstance';

export interface AnalyticsData {
  summary: {
    totalTasks: number;
    completedTasks: number;
    overdueTasks: number;
    totalProjects: number;
    totalClients: number;
    totalUsers: number;
    completionRate: number;
    totalQuoted: number;
    totalAgreed: number;
  };
  statusCounts: Record<string, number>;
  priorityCounts: Record<string, number>;
  typeCounts: Record<string, number>;
  activityByDay: Record<string, { created: number; completed: number }>;
  userWorkload: Array<{
    userId: string;
    name: string;
    role: string;
    total: number;
    completed: number;
    overdue: number;
  }>;
}

export const fetchAnalytics = async (): Promise<AnalyticsData> => {
  const { data } = await api.get<AnalyticsData>('/analytics');
  return data;
};

export const exportAnalyticsCsv = async (): Promise<Blob> => {
  const { data } = await api.get('/analytics/export', { responseType: 'blob' });
  return data;
};
